import { addMFA as addMFAService, refreshTokens, verifyTotpToken } from '../../../services';

import AuthActions from '../../../state/Auth.actions';
import { shouldRefreshTokens } from '/b2b/authentication/state/Auth.selectors';

export const addMFA = mfaType => dispatch => {
    dispatch(AuthActions.setPreferredMfaBegin(mfaType));

    return addMFAService(mfaType)
        .then(response => {
            return dispatch(AuthActions.setPreferredMfaSuccess(mfaType, response));
        })
        .catch(error => {
            const { message } = error;
            dispatch(AuthActions.setPreferredMfaFailure(mfaType, message));

            throw message;
        });
};

export const verify = params => (dispatch, getState) => {
    return verifyTotpToken(params).then(async () => {
        const session = await refreshTokens();
        shouldRefreshTokens(getState(), session) &&
            dispatch(AuthActions.refreshTokens(session.tokens));
        return addMFA('TOTP')(dispatch);
    });
};
